module.exports = __webpack_public_path__ + "img/Laskap_verplicht.a0bcdff7.jpg";